import { throwError } from "@saleshub/utils";

/**
 * @description Generate RGB code array from the HEX color code.
 * @param hex Color code at the HEX.
 * @returns Tuple of the RGB code chunks.
 */
function hexToRgb(hex: string): [number, number, number] {
  if (hex.length !== 6) {
    // default rgb color
    return [113, 182, 188];
  }

  const [rgbHex0, rgbHex1, rgbHex2] = hex.match(/.{1,2}/g) ?? throwError("`hexToRgb` could not find a match.");
  return [Number.parseInt(rgbHex0, 16), Number.parseInt(rgbHex1, 16), Number.parseInt(rgbHex2, 16)];
}

/**
 * @description Generate colors set palette with 2 colors. 2nd one with 50% opacity.
 * @param primaryHex Color code at the HEX.
 * @returns Tuple of primary/secondary colors.
 */
export function getColorsPalette(primaryHex: string): [string, string] {
  const [rgb0, rgb1, rgb2] = hexToRgb(primaryHex.replace(/#/g, ""));
  return [`rgb(${rgb0},${rgb1},${rgb2})`, `rgb(${rgb0},${rgb1},${rgb2},.5)`];
}
